import React from 'react';
import { Dispatch } from "redux";
import '../../App.css';
import { DefaultButton, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, Stack, TextField } from '@fluentui/react';
import { connect } from 'react-redux';
import { AppState } from '../RootReducer';
import { IUtente } from '../../api/Models';
import { AdminAction, adminUpdRequest, AdminUpdRequest } from '../controller/admin/Actions';

interface IUserAdminPanelProps {
  errorMsg: string | null;
  user: IUtente | null;
  close: () => void;
  aggiorna: (user: IUtente) => AdminUpdRequest;
}

interface IUserAdminPanelState {
  idUtente: number | null;
  nome: string;
  email: string;
  telefono: string;
  error: string | null;
}

class UserAdminPanel extends React.Component<IUserAdminPanelProps, IUserAdminPanelState> {
  constructor(props: IUserAdminPanelProps) {
    super(props);
    this.state = {
      idUtente: this.props.user?.idUtente || null,
      nome: this.props.user?.nome || '',
      email: this.props.user?.email || '',
      telefono: this.props.user?.telefono || '',
      error: null
    };
    this.confirm = this.confirm.bind(this);
    this.close = this.close.bind(this);
    this.onRenderFooterContent = this.onRenderFooterContent.bind(this);
    this.onChangeNome = this.onChangeNome.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangeTelefono = this.onChangeTelefono.bind(this);
  }

  static getDerivedStateFromProps(props: IUserAdminPanelProps, state: IUserAdminPanelState) {
    if (props.user) {
      if (props.user.idUtente !== state.idUtente) {
        return {
          idUtente: props.user?.idUtente,
          nome: props.user?.nome,
          email: props.user?.email,
          telefono: props.user?.telefono,
          error: null
        };
      }
    } else {
      if (state.idUtente) {
        return {
          idUtente: null,
          nome: '',
          email: '',
          telefono: '',
          error: null
        }
      }
    }

    return null;
  }

  private confirm() {
    // Valido i campi
    if (!this.state.nome || this.state.nome.trim().length === 0) {
      this.setState({ error: 'Campo nome obbligatorio.' });
      return;
    }
    // Chiama la funzione di salva dati citofono
    if (this.props.user) {
      let updUser: IUtente = {...this.props.user};
      updUser.nome = this.state.nome;
      updUser.email = this.state.email;
      updUser.telefono = this.state.telefono;
      this.props.aggiorna(updUser);
    }
  }

  private close() {
    // Azzero i campi per evitare che rimangano valorizzati tra due invocazioni
    this.setState({ error: null, nome: '', email: '', telefono: '' });
    // Chiamo il metodo di chiusura
    this.props.close();
  }
  private onRenderFooterContent() {
    return (
      <div>
        <PrimaryButton key="confimDglApprovaBtn" onClick={this.confirm} text="Salva" />
        <DefaultButton key="undoDglApprovaBtn" onClick={this.close} text="Chiudi" />
      </div>
    );
  }

  private onChangeNome = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    this.setState({ nome: newValue || '' });
  }

  private onChangeEmail = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    this.setState({ email: newValue || '' });
  }

  private onChangeTelefono = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    this.setState({ telefono: newValue || '' });
  }

  public render(): JSX.Element {

    return (
      <Panel
        isOpen={this.props.user != null}
        hasCloseButton={false}
        type={PanelType.smallFixedFar}
        headerText='Modifica dati amministratore'
        onRenderFooterContent={this.onRenderFooterContent}
        isFooterAtBottom={true}
      >
        <Stack tokens={{ childrenGap: 15 }}>
          {this.state.error && (
            <MessageBar
              messageBarType={MessageBarType.error}
            >
              {this.state.error}
            </MessageBar>
          )}
          <TextField
            label="Nome"
            value={this.state.nome}
            onChange={this.onChangeNome}
            maxLength={200}
            required
          />
          <TextField
            label="Email"
            value={this.state.email}
            onChange={this.onChangeEmail}
            maxLength={200}
          />
          <TextField
            label="Telefono"
            value={this.state.telefono}
            onChange={this.onChangeTelefono}
            maxLength={200}
          />
        </Stack>
      </Panel>
    );
  }
}

const MapStateToProps = (store: AppState) => {
  return {
    errorMsg: store.admin?.error,
  };
};

const MapDispatchToProps = (dispatch: Dispatch<AdminAction>) => ({
  aggiorna: (user: IUtente) => dispatch(adminUpdRequest(user))
});

export default connect(
  MapStateToProps,
  MapDispatchToProps
)(UserAdminPanel);